<template>
  <div>
    <Nav />
    <h3 class="titleAddEm">Assisted person information<span style="font-size:12px; color:red; margin-left:10px;">Please provide true information of your colleagues to avoid inconvenience.</span></h3>
    <el-form :model="ruleForm2" ref="ruleForm" label-width="100px" class="demo-ruleForm from-wrapAddem">
      <div @click="showEmailTip=false">
        <div>
          <!-- 头像 -->
          <div
            style='text-align:left;'
            class="form-item"
            label="Photo"
            prop=""
            v-if="PhotoModel"
          >
            <div>Photo<b v-if="IsRequiredPhoto" style="color: red">*</b></div>
            <div style="width:100%; text-align:center;">
              <img :src="pmp" style="width:150px;" v-if="!photoImg" alt="" @click="uploadPicture('flagImg')">
              <span class="photoImg" v-else>
                <img :src="photoImg" style="width:120px;" alt="" @click="uploadPicture('flagImg')">
                <div class="photoBtns">
                  <el-button size="small" @click="deletePhoto">Delete</el-button>
                  <el-button size="small" @click="uploadPicture('flagImg')">Re upload</el-button>
                </div>
              </span>
            </div>
          </div>
        </div>
        <div v-for="(item,index) in inputCofigData" :key="index">
          <!-- 姓名 -->
          <div
            class="form-item"
            :label="item.Etitle"
            prop="rgname"
            v-if="item.name==='PsnName'&&item.optional"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              @blur="clearSpace('userName')"
              v-model="ruleForm2.userName"
              :name="item.name"
              :placeholder="item.Eplaceholder"
              maxlength="50"
            ></el-input>
          </div>
          <!-- 公司 -->
          <div
            class="form-item"
            :label="item.Etitle"
            v-if="item.name==='PsnComName'&&item.optional"
            prop="rgComName"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              @blur="clearSpace('comName')"
              v-model="ruleForm2.comName"
              :name="item.name"
              :placeholder="item.Eplaceholder"
              maxlength="50"
            ></el-input>
          </div>
          <!-- 性别 -->
          <div
            class="form-item sex"
            :label="item.Etitle"
            prop="rgSex"
            v-if="item.name==='PsnGender'&&item.optional"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-radio v-model="ruleForm2.sex" checked label="先生" @change="cacheInput">先生</el-radio>
            <el-radio v-model="ruleForm2.sex" label="女士" @change="cacheInput">女士</el-radio>
          </div>
          <!-- 职务 -->
          <div
            class="form-item"
            :label="item.Etitle"
            v-if="item.name==='PsnRank'&&item.optional"
            prop="rgRank"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              @blur="clearSpace('rank')"
              v-model="ruleForm2.rank"
              :name="item.name"
              :placeholder="item.Eplaceholder"
              maxlength="50"
            ></el-input>
          </div>
          <!-- 部门 -->
          <div
            class="form-item"
            :label="item.Etitle"
            v-if="item.name==='PsnDept'&&item.optional"
            prop="rgDepar"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              @blur="clearSpace('depar')"
              v-model="ruleForm2.depar"
              :name="item.name"
              :placeholder="item.Eplaceholder"
              maxlength="50"
            ></el-input>
          </div>
          <!-- 手机 -->
          <div
            class="form-item"
            :label="item.Etitle"
            v-if="item.name==='PsnMobile'&&item.optional"
            prop="rgIphone"
          >
            <div>
              {{item.Etitle}}
            </div>
            <el-input
              v-model="ruleForm2.iphone"
              @keyup.native="clearSpace('iphone',item)"
              :placeholder="item.Eplaceholder"
              maxlength="11"
              :name="item.name"
              @blur="phoneCheck(item.name)"
            ></el-input>
          </div>

          <!-- 国家 -->
          <div
            class="form-item"
            :label="item.Etitle"
            prop="rgEmptyCountry"
            v-if="showCountry&&item.name==='PsnCountry'&&item.optional"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-select
              v-model="ruleForm2.country"
              :loading="isLoading"
              @visible-change="loadCountry"
              @change="changeCountry"
              :placeholder="item.Eplaceholder"
              :name="item.name"
            >
              <el-option label="China" value="086"></el-option>
              <el-option
                v-for="(item,index) in countryArr"
                :label="item.zptECity"
                :value="item.zptCityCode"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <!-- 地址 -->
          <div class="form-item" :label="item.title" v-if="item.name=='PsnAddress'&&item.optional" prop="rgAddr">
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              @blur="clearSpace('addr')"
              v-model="ruleForm2.addr"
              :placeholder="item.Eplaceholder"
              :name="item.name"
              error="dsfs"
              maxlength="50"
            ></el-input>
          </div>
          <!-- 邮箱 -->
          <div
            class="form-item"
            :label="item.Etitle"
            v-if="item.name==='PsnEmail'&&item.optional"
            prop="rgEmeil"
            :hide-required-asterisk="item.required"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              maxlength="50"
              :name="item.name"
              @blur="clearSpace('email',item)"
              v-model="ruleForm2.email"
              :placeholder="item.Eplaceholder"
              @input="changeEmail"
              error
            ></el-input>
            <div class="email-tip" v-if="item.name==='PsnEmail'&&showEmailTip">
              <div
                class="email-tip-option"
                v-for="(item1,index) in emailArr"
                :key="index"
                @click="chooseEmailSuffix(item1,item.name)"
              >{{ruleForm2.email.split('@')[0]+item1}}</div>
            </div>
          </div>
          <!-- </el-form-item> -->
          <!-- 网址 -->
          <div
            class="form-item"
            :label="item.Etitle"
            v-if="item.name==='PsnWebUrl'&&item.optional"
            prop="rgWebUrl"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              maxlength="50"
              :name="item.name"
              @blur="clearSpace('webUrl')"
              :placeholder="item.Eplaceholder"
              v-model="ruleForm2.webUrl"
              class="input-with-select"
              @change="cacheInput"
            ></el-input>
          </div>
          <!-- 传真 -->
          <div
            class="tel"
            :label="item.title"
            v-if="item.name==='PsnFax'&&item.optional"
            prop="rgFax"
          >
            <div>
              {{item.title}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <div style="width:88%;display: flex;align-items:center;">
              <el-input
                @keyup.native="clearSpace('gNum')"
                style="width: 30%;min-width: 66px;"
                v-model="ruleForm2.gNum"
                placeholder="国家号"
                maxlength="4"
              ></el-input>
              <span style="display: inline-block;line-height: 50px">-</span>
              <el-input
                @keyup.native="clearSpace('cNum')"
                style="width: 30%;min-width: 66px;"
                v-model="ruleForm2.cNum"
                placeholder="区号"
                maxlength="11"
                v-if="ruleForm2.gNum=='086'||ruleForm2.gNum=='86'"
              ></el-input>
              <span
                v-if="ruleForm2.gNum=='086'||ruleForm2.gNum=='86'"
                style="display: inline-block;line-height: 50px"
              >-</span>
              <el-input
                @keyup.native="clearSpace('faxNum')"
                v-model="ruleForm2.faxNum"
                placeholder="传真号"
                :name="item.name"
                class="tel"
              ></el-input>
            </div>
          </div>
          <!-- 座机 -->
          <div
            class="form-item"
            :label="item.Etitle"
            v-if="item.name==='PsnTel'&&item.optional"
            prop="rgTel"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <div style="width:88%;display: flex;align-items:center;">
              <el-input
                @keyup.native="clearSpace('gNum')"
                style="width: 30%;min-width: 66px;"
                v-model="ruleForm2.gNum"
                placeholder="Country code"
                maxlength="4"
              ></el-input>
              <!-- <span style="display: inline-block;line-height: 50px">-</span>
              <el-input
                @keyup.native="clearSpace('cNum')"
                style="width: 30%;min-width: 66px;"
                v-model="ruleForm2.cNum"
                placeholder="Area code"
                maxlength="11"
                v-if="ruleForm2.gNum=='086'||ruleForm2.gNum=='86'"
              ></el-input> -->
              <span
                v-if="ruleForm2.gNum=='086'||ruleForm2.gNum=='86'"
                style="display: inline-block;line-height: 50px"
              >-</span>
              <el-input
                @keyup.native="clearSpace('telNum')"
                v-model="ruleForm2.telNum"
                placeholder="Fax code"
                :name="item.name"
                class="tel"
              ></el-input>
            </div>
          </div>
          <!-- 行业 -->
          <div
            class="form-item"
            :label="item.title"
            v-if="item.name==='PsnTrade'&&item.optional"
            prop="rgEmptyIndustry"
            palceholder="请选择行业"
          >
            <div>
              {{item.title}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-select v-model="ruleForm2.industry" @change="cacheInput" :name="item.name">
              <el-option v-for="(item,index) in item.data" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <!-- 身份证 -->
          <div
            class="form-item"
            :label="item.Etitle"
            v-if="item.name==='PsnIDCard'&&item.optional"
            prop="rgCId"
          >
            <div>
              {{item.Etitle}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              maxlength="18"
              :name="item.name"
              @keyup.native="clearSpace('cId')"
              v-model="ruleForm2.cId"
              :placeholder="item.Eplaceholder"
              @change="cacheInput"
              @blur="cIdCheck(item.name)"
            ></el-input>
          </div>
          <!-- pass -->
          <div
            class="form-item"
            :label="item.title"
            v-if="item.name==='PsnLoginPwd'&&item.optional"
            prop="rgPassword"
          >
            <div>
              {{item.title}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              maxlength="18"
              @blur="clearSpace('password')"
              type="password"
              v-model="ruleForm2.password"
              :placeholder="item.placeholder"
              @change="cacheInput"
              :name="item.name"
            ></el-input>
          </div>
          <!-- 确认密码 -->
          <div
            class="form-item"
            label="确认密码"
            v-if="item.name==='PsnLoginPwd'&&item.optional"
            prop="confirmPassword"
          >
            <div>
              确认密码
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              maxlength="18"
              @keyup.native.space.passive="clearSpace('confirmPassword')"
              type="password"
              v-model="confirmPassword"
              placeholder="请再次输入密码"
              @change="cacheInput"
              name="confirmPassword"
            ></el-input>
          </div>
          <!-- 邮编 -->
          <div
            class="form-item"
            :label="item.title"
            v-if="item.name=='PsnZipCode'&&item.optional"
            prop="rgPostcode"
          >
            <div>
              {{item.title}}
              <b v-if="item.required" style="color: red">*</b>
            </div>
            <el-input
              @keyup.native="clearSpace('postcode')"
              v-model="ruleForm2.postcode"
              :placeholder="item.placeholder"
              @change="cacheInput"
              :name="item.name"
            ></el-input>
          </div>
        </div>
        <!-- 授权 -->
        <div class="privacySwitch" v-if="privacySwitch&&privacyInfo">
          <el-checkbox v-model="isChecked">{{privacyInfo}}</el-checkbox>
        </div>
        <div class="AddEmbtnbox">
          <el-button
            :style="btnAllStyle"
            type="primary"
            class="subEm-submit-btn"
            :loading="showBtnLoading"
            @click="submit('ruleForm')"
          >Register</el-button>
        </div>
      </div>
    </el-form>
    <div class="AddEmbtnbox">
      <el-button
        :style="btnAllStyle"
        type="primary"
        class="subEm-submit-btn"
        @click="isAllDisabled=false"
        v-if="isAllDisabled"
      >Edit</el-button>
    </div>
    <!-- 剪裁组件弹窗 -->
    <el-dialog
      title="Select photo"
      :visible.sync="cropperModel"
      width="800px"
      center
      >
     <cropper-image
      :Name="cropperName"
      @uploadImgSuccess = "handleUploadSuccess"
      ref="child">
     </cropper-image>
    </el-dialog>
    <!--查看头像-->
    <el-dialog
        title="Photo"
        :visible.sync="imgVisible"
        center>
      <img :src="imgName" v-if="imgVisible" style="width: 100%" alt="查看">
    </el-dialog>
  </div>
</template>
<script>
import api from '../api'
import utils from '../utils'
import regExp from '../utils/regExp.js'
import Nav from '../components/Nav'
import pmp from '../../static/img/pmp.png'
import CropperImage from '../components/CropperImage.vue';
export default {
  name: 'AddEmployee',
  components: {
    Nav,
    CropperImage
  },
  data() {
    return {
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      isAllDisabled: false,
      inputCofigData: [], //  input 标签配置数据
      bannerImg: '',
      ruleForm2: {
        tabindex: 1,
        industry: '', //  行业
        userName: '', //  姓名
        comName: '', //  公司名
        sex: '',
        rank: '', //  职务
        depar: '', //  部门
        iphone: '',
        code: '', //  验证码
        email: '',
        webUrl: '',
        gNum: '', //  国家号前缀 :86
        gNum1: '',
        cNum: '', //  城市号前缀： 0312
        faxNum: '', //  传真座机号
        telNum: '', //  座机号
        cId: '', //  身份证号
        postcode: '', //  邮编
        remark: '', //  备注
        password: '',
        country: '',
        province: '',
        city: '',
        telGnum: '',
        addr: '',
        authorization: false
      },
      emailCopy: '',
      emailArr: [
        '@qq.com',
        '@163.com',
        '@126.com',
        '@yeah.net',
        '@vip.sina.com',
        '@sina.com',
        '@msn.com',
        '@hotmail.com',
        '@aol.com',
        '@ask.com',
        '@live.com'
      ],
      options4: [],
      stepNum: 1,
      showCodeBtn: false, //  显示 code btn
      codeText: '获取验证码',
      countryArr: [], //  国家 or 特区 Arr
      provinceArr: [], //  省
      cityArr: [], //  城市
      showCountry: true, //  默认显示
      showProvince: false, //
      showCity: false,
      rg: /[0-9]{11}/,

      radio: 1, //  男女
      selectHttp: 'https://  ', //  选择协议
      isLoading: true,
      showEmailTip: false,
      privacySwitch: false, //  是否显示 授权信息;
      isChecked: true, //  是否已经授权
      privacyInfo: '', //  授权信息
      showBtnLoading: false,
      isPhoneCheck: true, //  是否查重通过
      isEmailCheck: true, //  是否查重通过
      isCidCheck: true, //  是否查重通过
      ExhID: sessionStorage.getItem('ExhID'),
      isConsistencyIdCard: sessionStorage.getItem('isConsistencyIdCard') || '',
      confirmPassword: '', // 确认密码
      PhotoModel: JSON.parse(sessionStorage.getItem('PhotoModel')) || false,
      photoImg: '',
      IsRequiredPhoto: JSON.parse(sessionStorage.getItem('IsRequiredPhoto')) || false,
      pmp: pmp,
      // 裁切图片参数
      cropperModel: false,
      cropperName: '',
      imgName: '',
      imgVisible: false
    }
  },
  computed: {
    faxNumber: function() {
      // 传真号全拼
      var str = ''
      if (this.ruleForm2.gNum === '086') {
        str =
          this.ruleForm2.gNum +
          '-' +
          this.ruleForm2.cNum +
          '-' +
          this.ruleForm2.faxNum
      } else {
        str = this.ruleForm2.gNum + '-' + this.ruleForm2.faxNum
      }
      return str
    },
    telNumber: function() {
      var str = ''
      if (this.ruleForm2.gNum === '086') {
        str =
          this.ruleForm2.gNum +
          // '-' +
          // this.ruleForm2.cNum +
          '-' +
          this.ruleForm2.telNum
      } else {
        str = this.ruleForm2.gNum + '-' + this.ruleForm2.telNum
      }
      return str
    }
  },
  mounted() {
    this.loadInputConfig()
    this.loadPageConfig()
    utils.setThemeColor()
    this.token = sessionStorage.getItem('token')
    this.bannerImg = sessionStorage.getItem('bannerImg')
    this.initData()
  },
  methods: {
    // 删除头像
    deletePhoto() {
      this.photoImg = ''
    },
    // 头像设置
    uploadPicture(name) {
      this.cropperName = name;
      this.cropperModel = true;
    },
    // 图片上传成功后
    handleUploadSuccess (data) {
      this.photoImg = data
      this.cropperModel = false;
    },
    clearSpace: function(n, item) {
      var obj = this.ruleForm2
      if (
        n === 'userName' ||
        n === 'comName' ||
        n === 'rank' ||
        n === 'depar' ||
        n === 'addr' ||
        n === 'email' ||
        n === 'webUrl' ||
        n === 'remark' ||
        n === 'cId'
      ) {
        obj[n] = obj[n].trim()
      } else if (
        n === 'iphone' ||
        n === 'code' ||
        n === 'gNum' ||
        n === 'faxNum' ||
        n === 'cNum' ||
        n === 'telNum' ||
        n === 'postcode'
      ) {
        // 数字
        obj[n] = obj[n].replace(/\D/g, '')
      } else {
        obj[n] = obj[n].trim()
      }

      this.ruleForm2 = obj

      if (n === 'email') {
        // 查重
        this.emailCheck(item.name)
      }
      return false
    },
    phoneCheck: function(names) {
      var obj = this.ruleForm2
      if (obj.iphone && obj.iphone.length !== 11) {
      } else if (obj.iphone && !regExp.regCheckCnMobile.test(obj.iphone)) {
      } else if (regExp.regCheckCnMobile.test(obj.iphone)) {
        var param = {
          exhid: this.ExhID,
          PsnMobile: obj.iphone
        }
        api.mobileRepeat(param).then(res => {
          if (res.data.status === 'OK') {
            this.isPhoneCheck = true
          } else {
            this.$alert(res.data.ErrorEMsg, {
              callback: function() {
                document.getElementsByName(names)[0].focus()
              }
            })
            this.isPhoneCheck = false
          }
        })
      } else if (regExp.notEmpty.test(obj.iphone)) {
      }
    },
    emailCheck: function(names) {
      var obj = this.ruleForm2
      if (obj.email && !regExp.regCheckEmail.test(obj.email)) {
        //  this.$alert('邮箱格式填写错误,请重新输入')
      } else if (obj.email && regExp.regCheckEmail.test(obj.email)) {
        var param = {
          exhid: this.ExhID,
          PsnEmail: obj.email
        }
        api.emailRepeat(param).then(res => {
          if (res.data.status === 'OK') {
            this.isEmailCheck = true
          } else {
            this.$alert(res.data.ErrorEMsg, {
              callback: function() {
                document.getElementsByName(names)[0].focus()
              }
            })
            this.isEmailCheck = false
          }
        })
        //  },200)
      } else if (regExp.notEmpty.test(obj.email)) {
        //  this.isEmailCheck=true;
      }
    },
    cIdCheck: function(names) {
      if (!utils.regCId(this)) {
        return ''
      }
      var param = {
        PsnIDCard: this.ruleForm2.cId,
        ExhID: this.ExhID
      }
      api.IDCardRepeat(param).then(res => {
        if (res.data.status === 'OK') {
          this.isCidCheck = true
        } else {
          this.$alert(res.data.ErrorEMsg, {
            callback: function() {
              document.getElementsByName(names)[0].focus()
            }
          })
          this.isCidCheck = false
        }
      })
    },

    initData: function() {
      api
      .getRegistInfo({
        ExhID: this.ExhID,
        PsjID: sessionStorage.getItem('PsjID')
      })
      .then(res => {
        if (res.data.status === 'OK') {
          var data = res.data.Data
          var obj = this.ruleForm2
          obj.comName = data.PsnComName
          obj.remark = data.PsnRemark
          if (data.PsnTel !== null) {
            obj.telNum = data.PsnTel.indexOf('-') > -1 ? data.PsnTel.split('-')[data.PsnTel.split('-').length - 1] : data.PsnTel
          }
          obj.webUrl = data.PsnWebUrl
          // if (obj.country === '中国大陆' || obj.country === '中国') {
            obj.gNum = '086'
            if (data.PsnTel && data.PsnTel.indexOf('-') > -1) {
              let arr = data.PsnTel.split('-')
              if (arr.length === 3) {
                obj.cNum = arr[1]
              }
            } else if (data.PsnFax && data.PsnFax.indexOf('-') > -1) {
              let arr = data.PsnFax.split('-')
              if (arr.length === 3) {
                obj.cNum = arr[1]
              }
            }
          // } else {
          //   if (data.PsnTel && data.PsnTel.indexOf('-') > -1) {
          //     obj.gNum = data.PsnTel.split('-')[0]
          //   } else if (data.PsnFax && data.PsnFax.indexOf('-') > -1) {
          //     obj.gNum = data.PsnFax.split('-')[0]
          //   }
          // }
          this.ruleForm2 = obj
        }
        this.previousEmail = this.ruleForm2.email
      })
    },
    changeEmail: function() {
      this.cacheInput()
      if (this.ruleForm2.email && this.ruleForm2.email.indexOf('@') === -1) {
        this.showEmailTip = true
      } else {
        this.showEmailTip = false
      }
    },
    chooseEmailSuffix: function(str, names) {
      this.ruleForm2.email = this.ruleForm2.email.split('@')[0] + str
      this.showEmailTip = false
      this.emailCheck(names) // 邮箱查重
    },
    cacheInput: function() {
      sessionStorage.setItem('cacheInfo', JSON.stringify(this.ruleForm2))
    },
    callback: function(res) {
      this.aa = res.val
    },

    loadCity: function(v) {
      var param = {
        ExhID: this.ExhID,
        zptProvince: this.ruleForm2.province
      }
      api.getCity(param).then(res => {
        if (res.data.status === 'OK') {
          var data = res.data.Data
          this.cityArr = data
        }
      })
    },
    changeCity: function(v) {
      var obj = this.ruleForm2
      var event = window.event
      var target = event.target || event.srcElement
      obj.cNum = v
      obj.city = target.innerText
      this.ruleForm2 = obj
      sessionStorage.setItem('cacheInfo', JSON.stringify(this.ruleForm2))
    },

    changeCountry: function(v) {
      var obj = this.ruleForm2
      obj.gNum1 = obj.gNum = obj.telGnum = v
      var event = window.event
      var target = event.target || event.srcElement
      obj.country = target.innerText
      if (target.innerText && target.innerText !== '中国大陆') {
        this.ruleForm2.province = ''
        this.ruleForm2.city = ''
      }
      this.ruleForm2 = obj
      sessionStorage.setItem('cacheInfo', JSON.stringify(this.ruleForm2))
    },

    changeProvince: function(v) {
      this.ruleForm2.city = ''
      this.cacheInput()
    },
    loadProvince: function(v) {
      var param = {
        ExhID: this.ExhID
      }
      api.getProvince(param).then(res => {
        var data = res.data.Data
        if (data && data.length > 0) {
          this.provinceArr = data
          this.showProvince = true
        } else {
          this.provinceArr = []
          this.cityArr = []
        }
      })
    },
    loadCountry: function(v) {
      // 加载国家
      if (!v) {
        return ''
      }
      var param = {
        ExhID: this.ExhID
      }
      api.getCountry(param).then(res => {
        if (res.data.status === 'OK') {
          var data = res.data.Data
          var arr = []
          for (var i = 0; i < data.length; i++) {
            arr.concat(data[i])
          }
          this.countryArr = data
        } else {
          this.$alert(res.ErrorEMsg)
        }
        this.isLoading = false
      })
    },
    loadInputConfig: function() {
      var param = { ExhID: this.ExhID, RegistType: 'pc' }
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.getinput(param).then(res => {
        loading.close()
        if (res.data.status === 'OK') {
          this.inputCofigData = res.data.data.sort(this.sequence)
          loading.close()
        }
      })
    },
    sequence (a, b) {
      if (parseInt(a.BisSort) > parseInt(b.BisSort)) {
        return 1;
      } else if (parseInt(a.BisSort) < parseInt(b.BisSort)) {
        return -1
      } else {
        return 0;
      }
    },
    checkRepeatEmailCidCode: function(cb) {
      var param = {
        PsnEmail: this.ruleForm2.email,
        //  PsnEmail:"109298438@qq.com"
        ExhID: this.ExhID
      }
      api.emailRepeat(param).then(res => {
        if (res.data.status === 'OK') {
          // 进行下一重操作 身份证查重
          var param = {
            PsnIDCard: this.ruleForm2.cId,
            ExhID: this.ExhID
          }
          api.IDCardRepeat(param).then(res => {
            if (res.data.status === 'OK') {
              if (cb) {
                cb()
              }
            } else {
              this.$alert(res.data.ErrorEMsg, 'Tips', {
                dangerouslyUseHTMLString: true
              })
            }
          })
        } else {
          this.$alert(res.data.ErrorEMsg, 'Tips', {
            dangerouslyUseHTMLString: true
          })
        }
      })
    },
    submitInfo: function() {
      var obj = this.ruleForm2
      let telNumber = obj.telNum ? obj.telGnum + '-' + obj.telNum : ''
      var param = {
        ExhID: this.ExhID,
        WapToken: sessionStorage.token,
        IfSubmit: true,
        FaceID: '',
        RegistType: 'pc',
        InviteID: sessionStorage.getItem('PsnID'),
        InviteType: 'Assist',
        InviteCode: 0,
        PsnMobile: obj.iphone,
        PsnName: obj.userName,
        PsnComName: obj.comName,
        PsnGender: obj.sex,
        PsnRank: obj.rank,
        PsnDept: obj.depar,
        PsnCountry: obj.country,
        PsnEmail: obj.email,
        PsnWebUrl: obj.webUrl,
        PsnFax: obj.faxNum ? this.faxNumber : '',
        // PsnTel: obj.telNum ? this.telNumber : '',
        PsnTel: telNumber,
        PsnTrade: obj.industry,
        PsnIDCard: obj.cId,
        PsnLoginPwd: obj.password,
        PsnZipCode: obj.postcode,
        PsnRemark: obj.remark,
        PsnProvince: obj.province,
        PsnCity: obj.city,
        PsnCode: obj.code,
        PsnAddress: obj.addr,
        PsnCountryCode: obj.gNum1 === '086' ? obj.gNum1.slice(1) : obj.gNum1,
        PhotoUrl: this.photoImg
      }
      api.saveVisitor(param).then(res => {
        if (res.data.status === 'OK') {
          sessionStorage.setItem('PsnMobile', param.PsnMobile)
          let _this = this
          this.$alert('Successfully Registered', {
            callback: function() {
              _this.$router.push('/helpRegister')
            }
          })
          if (res.data.PsjID) {
            sessionStorage.setItem('cacheInfo', '')
            this.$router.push('/helpRegister')
          }
        } else {
          this.$alert(res.ErrorEMsg, 'Tips！')
        }
      })
    },
    saveInfoMess: function() {
      var obj = this.ruleForm2
      var param = {
        ExhID: this.ExhID,
        WapToken: sessionStorage.token,
        IfSubmit: false,
        FaceID: '',
        RegistType: 'pc',
        InviteID: sessionStorage.getItem('InviteID')
          ? sessionStorage.getItem('InviteID')
          : 0,
        InviteType: sessionStorage.getItem('InviteType')
          ? sessionStorage.getItem('InviteType')
          : '',
        InviteCode: sessionStorage.getItem('InviteCode')
          ? sessionStorage.getItem('InviteCode')
          : '',
        PsnMobile: obj.iphone,
        PsnName: obj.userName,
        PsnComName: obj.comName,
        PsnGender: obj.sex,
        PsnRank: obj.rank,
        PsnDept: obj.depar,
        PsnCountry: obj.country,
        PsnEmail: obj.email,
        PsnWebUrl: obj.webUrl,
        PsnFax: obj.faxNum ? this.faxNumber : '',
        PsnTel: obj.telNum ? this.telNumber : '',
        PsnTrade: obj.industry,
        PsnIDCard: obj.cId,
        PsnLoginPwd: obj.password,
        PsnZipCode: obj.postcode,
        PsnRemark: obj.remark,
        PsnProvince: obj.province,
        PsnCity: obj.city,
        PsnCode: obj.code,
        PsnAddress: obj.addr,
        EntryPsjId: sessionStorage.getItem('PsjID'),
        PsnExtField2: '',
        PsnExtField1: '',
        PsnCountryCode: '',
        PsnFirstEName: '',
        PsnLastEName: ''
      }
      api.updateVisitor(param).then(res => {
        if (res.data.status === 'OK') {
          this.$router.push('helpRegister')
        } else {
          this.$alert(res.data.ErrorEMsg)
        }
      })
    },
    submit: function(elemRef) {
      var isGoAjax = this.regInfoMess()
      if (isGoAjax) {
        // 姓名身份证号一致性验证
        // 如果有身份证 没有国家或国家为中国大陆 进行一致性验证
        if (this.ruleForm2.cId && (this.ruleForm2.country === '中国大陆' || this.ruleForm2 === '') && this.isConsistencyIdCard === 'true') {
          utils.realNameVerification(this, this.ruleForm2.userName, this.ruleForm2.cId).then(resRealName => {
            if (resRealName === 'true') {
              this.submitInfo()
            } else {
              this.$alert('The name and ID number you entered are inconsistent.', 'Tips', {
              // this.$alert('您输入的姓名和身份证号不一致', 'Tips', {
                dangerouslyUseHTMLString: true
              })
            }
          })
        } else {
          this.submitInfo()
        }
      }
    },
    regInfoMess: function() {
      var arr = this.inputCofigData
      var obj = this.ruleForm2
      if (this.IsRequiredPhoto && !this.photoImg) { // 头像必填
        this.$alert('Please upload photo')
        return false;
      }
      for (var i = 0; i < arr.length; i++) {
        var o = arr[i]
        if (o.name === 'PsnName') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.userName)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.userName.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckCnName.test(obj.userName) &&
              !regExp.regCheckEnName.test(obj.userName)
            ) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.userName && obj.userName.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckCnName.test(obj.userName) &&
              !regExp.regCheckEnName.test(obj.userName) &&
              obj.userName
            ) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.userName = ''
          }
        } else if (o.name === 'PsnComName') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.comName)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.comName.length < 4) {
              this.$alert(o.Etitle + ' length cannot be less than 4 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
              //  }else if(!regExp.regCheckComName.test(obj.comName)){
            }
          } else if (o.optional) {
            if (obj.comName && obj.comName.length < 4) {
              this.$alert(o.Etitle + ' length cannot be less than 4 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
              //  }else if(!regExp.regCheckComName.test(obj.comName)&&obj.comName){
            }
          } else {
            obj.comName = ''
          }
        } else if (o.name === 'PsnGender') {
          if (o.required && o.optional) {
            if (!obj.sex) {
              this.$alert('请选择' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        } else if (o.name === 'PsnRank') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.rank)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.rank.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckRank.test(obj.rank)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.rank && obj.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckRank.test(obj.rank) && obj.rank) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.rank = ''
          }
        } else if (o.name === 'PsnDept') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.depar)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.depar.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckDepar.test(obj.depar)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.depar && obj.depar.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckDepar.test(obj.depar) && obj.depar) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.depar = ''
          }
        } else if (o.name === 'PsnCountry') {
          if (o.required && o.optional) {
            if (!obj.country) {
              this.$alert('Please select ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.country && obj.country !== 'China') {
              obj.province = ''
              obj.city = ''
            }
          }
        } else if (o.name === 'PsnProvince') {
          if (o.required && o.optional) {
            if (!obj.province && obj.country === 'China') {
              this.$alert('请选择' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        } else if (o.name === 'PsnCity') {
          if (o.required && o.optional) {
            if (!obj.city && obj.country === 'China') {
              this.$alert('请选择' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        } else if (o.name === 'PsnEmail') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.email)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckEmail.test(obj.email)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              regExp.regCheckEmail.test(obj.email) &&
              !this.isEmailCheck
            ) {
              this.$alert('This email has been registered in this exhibition！')
              return ''
            }
          } else if (o.optional) {
            if (!regExp.regCheckEmail.test(obj.email) && obj.email) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              regExp.regCheckEmail.test(obj.email) &&
              !this.isEmailCheck
            ) {
              this.$alert('This email has been registered in this exhibition！')
              return ''
            }
          } else {
            obj.email = ''
          }
        } else if (o.name === 'PsnWebUrl') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.webUrl)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regWebUrl.test(obj.webUrl)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!regExp.regWebUrl.test(obj.webUrl) && obj.webUrl) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.webUrl = ''
          }
        } else if (o.name === 'PsnFax') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.faxNum)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.faxNum.length < 7 || obj.faxNum.length > 8) &&
              obj.country === '中国大陆'
            ) {
              this.$alert('请输入7-8位的' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.faxNum.length < 5 || obj.faxNum.length > 11) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert('请输入5-11位的' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckTelCn.test(this.faxNumber) &&
              obj.country === '中国大陆'
            ) {
              this.$alert(o.Etitle + 'format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckTelEn.test(this.faxNumber) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert(o.Etitle + 'format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (
              obj.faxNum &&
              (obj.faxNum.length < 7 || obj.faxNum.length > 8) &&
              obj.country === '中国大陆'
            ) {
              this.$alert('请输入7-8位的' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.faxNum &&
              (obj.faxNum.length < 5 || obj.faxNum.length > 11) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert('请输入5-11位的' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.faxNum &&
              !regExp.regCheckTelCn.test(this.faxNumber) &&
              obj.country === '中国大陆'
            ) {
              this.$alert(o.Etitle + 'format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.faxNum &&
              !regExp.regCheckTelEn.test(this.faxNumber) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert(o.Etitle + 'format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        } else if (o.name === 'PsnTel') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.telNum)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.telNum.length < 7 || obj.telNum.length > 8) &&
              obj.country === 'China'
            ) {
              this.$alert('Please enter 7-8 digits ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.telNum.length < 5 || obj.telNum.length > 11) &&
              obj.country !== 'China'
            ) {
              this.$alert('Please enter 5-11 digits ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckTelEn.test(this.telNumber) &&
              obj.country !== 'China'
            ) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (
              obj.telNum &&
              (obj.telNum.length < 7 || obj.telNum.length > 8) &&
              obj.country === 'China'
            ) {
              this.$alert('Please enter 7-8 digits ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.telNum &&
              (obj.telNum.length < 5 || obj.telNum.length > 11) &&
              obj.country !== 'China'
            ) {
              this.$alert('Please enter 5-11 digits ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.telNum &&
              !regExp.regCheckTelCn.test(this.telNumber) &&
              obj.country === 'China'
            ) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.telNum &&
              !regExp.regCheckTelEn.test(this.telNumber) &&
              obj.country !== 'China'
            ) {
              this.$alert(o.title + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        } else if (o.name === 'PsnTrade') {
          if (o.required && o.optional) {
            if (!obj.industry) {
              this.$alert('请选择' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (!o.optional) {
            obj.industry = ''
          }
        } else if (o.name === 'PsnIDCard') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.cId)) {
              this.$alert('Please enter your ' + o.Etitle)
              // this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.country === 'China' && !utils.regCId(obj.cId)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              // this.$alert(o.title + '不合法,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!utils.regCId(obj.cId) && obj.cId && obj.country === 'China') {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              // this.$alert(o.title + '不合法,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.cId = ''
          }
        } else if (o.name === 'PsnLoginPwd') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.password)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.password.length < 6) {
              this.$alert(o.title + '长度不能小于6位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!this.confirmPassword) {
              this.$alert('请再次输入密码')
              document.getElementsByName('confirmPassword')[0].focus()
              return ''
            } else if (obj.password !== this.confirmPassword) {
              this.$alert('两次输入密码不一致')
              document.getElementsByName('confirmPassword')[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.password && obj.password.length < 6) {
              this.$alert(o.title + '长度不能小于6位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.password = ''
          }
        } else if (o.name === 'PsnZipCode') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.postcode)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.checkCnZipCode.test(obj.postcode)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!regExp.checkCnZipCode.test(obj.postcode) && obj.postcode) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.postcode = ''
          }
        } else if (o.name === 'PsnAddress') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.addr)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.addr.length < 6) {
              this.$alert(o.title + '长度不能小于6位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.checkAddress.test(obj.addr)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.addr && obj.addr.length < 6) {
              this.$alert(o.title + '长度不能小于6位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.addr && !regExp.checkAddress.test(obj.addr)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        }
      }
      if (this.privacySwitch && !this.isChecked) {
        this.$alert('请授权')
        return false
      }
      return true
    },
    loadPageConfig: function() {
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        //  ,page:'Login'
        page: 'AddInfo',
        Language: 'cn'
      }
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.getPage(param).then(res => {
        loading.close()
        if (res.data.status === 'OK') {
          var switchInfos = res.data.switchInfos
          for (var i = 0; i < switchInfos.length; i++) {
            if (switchInfos[i].name === 'PrivacySwitch') {
              this.privacySwitch = switchInfos[i].data
            }
          }
          var promptinfo = res.data.promptinfo

          for (let i = 0; i < promptinfo.length; i++) {
            if (promptinfo[i].name === 'PrivacyInfo') {
              this.privacyInfo = promptinfo[i].value
            }
          }
        } else {
          this.$alert(res.data.ErrorEMsg)
        }
      })
    }
  }
}
</script>
<style>
.AddEmbtnbox{
  text-align: center;
  padding: 30px 0;
}
.el-message-box {
  max-width: 80%;
}
.img-auto {
  width: 100%;
}
.titleAddEm {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding: 60px 80px 30px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.banner-box {
  width: 100%;

  margin: 0 auto;
}
.from-wrapAddem {
  padding: 14px;
  background: #fff;
}
.from-wrapAddem > div {
  max-width: 580px;
  margin: 0 auto;
}
.flex {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.flex-start {
  display: flex;
  justify-content: flex-start;
}
.tel .el-form-item__content {
  display: flex;
  justify-content: flex-start;
}
.code-btn {
  height: 40px;
}
.subEm-submit-btn {
  width: 50%;
}
.email-tip {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;

  color: #606266;
}
.email-tip .email-tip-option {
  padding: 0px 15px;
}
.email-tip .email-tip-option:hover {
  background: #f5f7fa;
  cursor: pointer;
}
.email-tip .email-tip-option {
  word-wrap: break-word;
  margin: 10px 0;
}
.privacySwitch {
  margin: 10px 0;
}
.privacySwitch .el-checkbox__label {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  vertical-align: top;
}
.form-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.form-item > div {
  min-width: 28%;
  line-height: 40px;
  text-align: right;
  padding-right: 8px;
}

.el-input,
.el-select {
  width: 100%;
}
.email-tip {
  position: absolute;
  width: 80%;
  left: 53%;
  top: 50px;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  z-index: 99;
}
.form-item > div.email-tip {
  text-align: left;
}
.form-item {
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/AddEmployee.vue